<template>
  <Modal :open="open" @closed="handleClose" dialog-size="modal-lg">
    <div class="modal-header border-0">
      <h5 class="modal-title m-0 fw-bold">
        <vue-feather type="file-text" size="20" class="me-2"></vue-feather>
        Request File from Employees
      </h5>
      <button @click="handleClose" type="button" class="btn-close outline-none" data-dismiss="modal" aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label for="fileName" class="form-label fw-semibold">File Name <span class="small fw-lighter">(Request single file)</span> <span class="text-danger">*</span></label>
          <input
            type="text"
            id="fileName"
            class="form-control"
            v-model="formData.name"
            placeholder="Enter file name"
            required
          >
        </div>
        <div class="mb-3">
          <label for="fileDescription" class="form-label fw-semibold">Description <span class="text-muted">(optional)</span></label>
          <textarea
            id="fileDescription"
            class="form-control"
            v-model="formData.description"
            placeholder="Enter file description"
            rows="3"
          ></textarea>
        </div>

        <hr class="my-4">

        <div class="mb-3">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <label class="form-label fw-semibold mb-0">Select Employees <span class="text-danger">*</span></label>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="selectAllEmployees"
                v-model="selectAll"
                @change="toggleSelectAll"
              >
              <label class="form-check-label fw-semibold" for="selectAllEmployees">
                Select All
              </label>
            </div>
          </div>

          <div class="employee-list-container border rounded p-3" style="max-height: 300px; overflow-y: auto;">
            <div v-if="employees.length === 0" class="text-center text-muted py-3">
              <vue-feather type="users" size="32" class="mb-2"></vue-feather>
              <p class="mb-0">No active employees found</p>
            </div>
            <div v-else class="row g-2">
              <div v-for="employee in employees" :key="employee.id" class="col-md-6">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'emp-' + employee.id"
                    :value="employee.id"
                    v-model="formData.employee_ids"
                  >
                  <label class="form-check-label" :for="'emp-' + employee.id">
                    {{ employee.first_name }} {{ employee.last_name }}
                    <span class="text-muted small">({{ employee.employee_no }})</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <small class="text-muted">{{ formData.employee_ids.length }} employee(s) selected</small>
        </div>
      </form>
    </div>
    <div class="modal-footer border-0 pt-0">
      <button
        type="button"
        class="btn btn-outline-secondary"
        @click="handleClose"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="handleSubmit"
        :disabled="!formData.name || formData.employee_ids.length === 0 || saving"
      >
        <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        Send Request
      </button>
    </div>
  </Modal>
</template>

<script>
import VueFeather from 'vue-feather';
import fileRequestService from "@/api/fileRequestService";

export default {
  name: "RequestFilesModal",
  components: { VueFeather },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    employees: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      formData: {
        name: '',
        description: '',
        employee_ids: []
      },
      selectAll: false,
      saving: false
    }
  },
  methods: {
    toggleSelectAll() {
      if (this.selectAll) {
        this.formData.employee_ids = this.employees.map(emp => emp.id);
      } else {
        this.formData.employee_ids = [];
      }
    },
    async handleSubmit() {
      if (!this.formData.name || this.formData.employee_ids.length === 0) {
        return;
      }

      this.saving = true;
      try {
        const response = await fileRequestService.createFileRequest(this.formData);
        if (response) {
          this.$emit('success');
          this.resetForm();
        }
      } catch (error) {
        console.error('Error requesting files:', error);
      } finally {
        this.saving = false;
      }
    },
    handleClose() {
      this.resetForm();
      this.$emit('closed');
    },
    resetForm() {
      this.formData = {
        name: '',
        description: '',
        employee_ids: []
      };
      this.selectAll = false;
    }
  },
  watch: {
    'formData.employee_ids'(newVal) {
      this.selectAll = newVal.length === this.employees.length && this.employees.length > 0;
    }
  }
}
</script>

<style scoped>
.employee-list-container {
  background-color: #f8f9fa;
}

.form-check-input:checked {
  background-color: #652aa3;
  border-color: #652aa3;
}
</style>
